import { createAction } from '@reduxjs/toolkit';

export const enterChimeMeetingAction = createAction('classroom/enterChimeMeetingAction');
export const errorAction = createAction('classroom/errorAction');
export const initAction = createAction('classroom/initAction');
export const joinMeetingAction = createAction('classroom/joinMeeting');
export const recordChimeMeetingAction = createAction('classroom/recordChimeMeetingAction');
export const setPopoutAction = createAction('classroom/setPopoutAction');
export const successAction = createAction('classroom/successAction');
export const toggleMuteSelfAction = createAction('classroom/toggleMuteSelfAction');
export const toggleRosterAttendeeMutedAction = createAction(
  'classroom/toggleRosterAttendeeMutedAction'
);
